import { call, put } from 'redux-saga/effects';

import { requestFailed } from '../../../bootstrap/redux/actions/RequestFailedAction';
import { CatalogChangeContentActions } from '../../../catalog/contentActions/CatalogChangeContactActions';
import { Messages } from '../../../codegen/Localize';
import { requestSpaceContents } from '../../actions/RequestSpaceContentsActions';
import { SetContactAction } from '../../actions/SetContactAction';
import { IContentInfo } from '../../models/IContentInfo';
import { reloadSpaceIfUpdatingCurrentSpace } from './RefreshContentSagas';


export function* handleSetContact(action: SetContactAction) {
  try {

    try {
      yield call(openContactDialog, action.item);
    } catch {
      return;
    }

    const maybeReloaded = yield call(reloadSpaceIfUpdatingCurrentSpace, [action.item]);
    if (!maybeReloaded) {
      yield put(requestSpaceContents());
    }
  } catch(e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function openContactDialog(externalContentItem: IContentInfo): Promise<any> {
  return CatalogChangeContentActions.confirmChangeContact(externalContentItem.contentType, externalContentItem);
}
